export const WindowWidth = {
  LAPTOP: 1024,
  TABLET: 768,
};
